// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { database16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-database': IconDatabase;
    }
}

/**
 * The icon component for the 'database' icon
 */
export class IconDatabase extends Icon {
    public constructor() {
        super(database16X16);
    }
}

registerIcon('icon-database', IconDatabase);
export const iconDatabaseTag = 'nimble-icon-database';
